module.exports = __webpack_public_path__ + "img/9788956603001.f864661d.jpg";